import { observable, action, makeObservable } from 'mobx';
import axios from 'axios';

class dragStore {
  drag_enabled=false;
  drag_manual_enabled=false;
  drag_custom_enabled=false;
  drag_manual_data= {};
  drag_type="";
  drag_source= {};
  dragging=false;

  par=null;
  constructor(par) {
    makeObservable(this,{
      drag_enabled:observable,
      drag_type:observable,
      drag_source:observable,
      dragging:observable,
      drag_custom_enabled:observable,
      drag_manual_enabled:observable,
      drag_manual_data:observable,
    })
    this.par=par;
  }
  toggleDrag() {
    this.drag_enabled=!this.drag_enabled;
  }
  drop(type,source,movePos,target) {
    if(type === "section") {

      // axios.post(`/sysapi/dynamic/${this.par.treeStore.category}/sections/move`,{
      axios.post(`${this.par.routes.move}`,{
        source_section:source.id,
        type:movePos,
        target_section:target.id
      }).then((data)=>{
        console.log('data.data',data.data);
        if(data.data.answer) {
          if(data.data.answer.roots_updated) {
            for(let i in data.data.answer.roots_updated) {
              this.par.treeStore.loadTreeData(data.data.answer.roots_updated[i]);
            }
          }
        }
      });
    }
  }

}

/*decorate(dragStore,{
  drag_enabled:observable,
  drag_type:observable,
  drag_source:observable,
  dragging:observable,
  drag_custom_enabled:observable,
  drag_manual_enabled:observable,
  drag_manual_data:observable,
});*/

export default dragStore;
